/* ─────────────────────────────────────────────────────────────────────────────
   GrowthOS migration — Executive dashboard — RTK Query slice. Company-wide
   "whole growth engine" view, real data from growthos_revenue_daily (rolled
   up from live MongoOrder data) + GrowthOsDeal + GrowthOsPerson.
   ──────────────────────────────────────────────────────────────────────────── */
import { createApi } from '@reduxjs/toolkit/query/react'
import { apiConstants, get } from '../common/constants'

const EXECUTIVE = apiConstants.GROWTHOS_ADMIN_EXECUTIVE

const run = async (promise) => {
  try {
    const res = await promise
    return { data: res?.data }
  } catch (err) {
    const r = err?.response
    return {
      error: {
        status: r?.status,
        data: r?.data,
        message: r?.data?.message || err.message,
      },
    }
  }
}

export const growthosExecutiveApiSlice = createApi({
  reducerPath: 'growthosExecutiveApi',
  baseQuery: () => ({ data: undefined }),
  tagTypes: ['Executive'],
  endpoints: (b) => ({
    getExecutiveDashboard: b.query({
      // URLSearchParams stringifies an `undefined` value as the literal text "undefined" —
      // only include `poc` in the params object when it's actually set, or the backend
      // receives poc="undefined" and filters the whole dashboard down to nothing.
      queryFn: ({ period, from, to, poc }) => run(get(EXECUTIVE, { period, from, to, ...(poc ? { poc } : {}) })),
      providesTags: ['Executive'],
    }),
  }),
})

export const { useGetExecutiveDashboardQuery } = growthosExecutiveApiSlice
